import { Component, inject, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { FileParamsFormComponent } from '../../../shared/components/file-params-form/file-params-form.component';
import {
  FileType,
  UploadShapefileComponent,
} from '../../../shared/components/upload-shapefile/upload-shapefile.component';
import { EnhancedLoadingService } from '../../../shared/services/enhanced-loading.service';
import { SmartOrpcClientService } from '../../../shared/services/smart-orpc-client.service';
import { SnackbarService } from '../../../shared/services/snackbar.service';
import { FeatureFlagsService } from '../../../shared/services/feature-flags.service';

@Component({
  selector: 'app-history-safra-new',
  imports: [
    UploadShapefileComponent,
    FileParamsFormComponent,
    MatIconModule,
    MatDividerModule,
    MatButtonModule,
  ],
  templateUrl: './history-safra-new.component.html',
  styleUrl: './history-safra-new.component.scss',
})
export class HistorySafraNewComponent {
  smartClient = inject(SmartOrpcClientService);
  loadingService = inject(EnhancedLoadingService);
  snackBar = inject(SnackbarService);
  private featureFlags = inject(FeatureFlagsService);

  // Observables para diferentes tipos de loading
  globalLoading$ = this.loadingService.global$;
  gridLoading$ = this.loadingService.grid$;
  inputLoading$ = this.loadingService.input$;
  buttonLoading$ = this.loadingService.button$;

  @ViewChild(FileParamsFormComponent)
  declare formComponent: FileParamsFormComponent;
  @ViewChild(UploadShapefileComponent)
  declare uploadComponent: UploadShapefileComponent;

  uploadedFileName: string | null = null;
  originalFileName: string | null = null;
  selectedFileType: FileType = 'spreadsheet';
  router = inject(Router);

  // Expor para o template
  get enabledFileTypes() {
    return this.featureFlags.getHistoricoEnabledFileTypes();
  }

  async onSubmit() {
    this.formComponent.form.markAllAsTouched();
    if (
      this.uploadComponent.fileCtrl.invalid ||
      this.formComponent.form.invalid ||
      !this.uploadedFileName
    ) {
      return;
    }

    const {
      contract,
      insurancePolicy,
      farmName,
      featurePrimaryKey,
      identityDocument,
      producer,
      car,
    } = this.formComponent.form.value;

    const res = await this.smartClient.client.historiesSafras.request({
      fileName: this.uploadedFileName!,
      contractFieldKey: contract ?? undefined,
      insurancePolicyKey: insurancePolicy ?? undefined,
      customerFarmNameKey: farmName ?? undefined,
      originalFileName: this.originalFileName ?? undefined,
      featurePrimaryKeyField: featurePrimaryKey!,
      identityDocumentField: identityDocument ?? undefined,
      producerField: producer ?? undefined,
      carFieldKey: car ?? undefined,
    });

    this.snackBar.alert(
      `Solicitação ${res.requestId} registrada com sucesso.`,
      -1,
    );
    this.navigateToList();
  }

  onFileUploaded(fileName: string | null) {
    this.uploadedFileName = fileName;
  }
  onOriginalFileName(originalName: string | null) {
    this.originalFileName = originalName;
  }
  onFileTypeChanged(fileType: FileType): void {
    this.selectedFileType = fileType;
  }
  navigateToList(): void {
    this.router.navigate(['/histories-safras']);
  }
}
